import React, { FC } from 'react';
import { Popup } from 'devextreme-react/popup';
import { ActionButton, HeadingItem } from 'components';
import { faTimesCircle } from '@fortawesome/pro-solid-svg-icons'
import './confirmation-popup.scss';
import { ButtonDetails } from 'types'

type Props = {
    isVisible: boolean,
    title: string,
    message?: string,
    render?: () => React.ReactNode;
    button1: ButtonDetails,
    button2?: ButtonDetails,
    isCloseButtonVisible?: boolean,
    onClickButton1: () => void,
    onClickButton2?: () => void,
    onClickCloseButton?: () => void,
    width?: number,
    height?: number
}

export const ConfirmationPopup: FC<Props> = ({ isVisible, title, width = 300, height = 250, message, render = () => <></>, button1, button2, isCloseButtonVisible = false, onClickButton1, onClickButton2, onClickCloseButton }) => {

    return (
        <Popup
            visible={isVisible}
            dragEnabled={false}
            closeOnOutsideClick={false}
            showTitle={false}
            width={width}
            height={height}
        >
            <div className="confirmation-popup-card">
                <HeadingItem
                    text={title}
                    rightHandIcon={isCloseButtonVisible ? { icon: faTimesCircle, size: '2x', color: 'black' } : undefined}
                    onClick={onClickCloseButton}
                />
                <div className={'confirmation-popup-content'}>
                    {message}
                    {render()}
                </div>
                <div className={'bottom-fix-action-row'}>
                    <ActionButton
                        icon={button1.icon}
                        buttonColor={button1.backgroundColor ? button1.backgroundColor : '#EB5757'}
                        onClick={onClickButton1}
                        buttonText={button1.text ?? 'No'}
                    />
                    {button2 &&
                        <ActionButton
                            icon={button2.icon}
                            buttonColor={button2.backgroundColor ? button2.backgroundColor : '#82BC24'}
                            onClick={onClickButton2}
                            buttonText={button2.text ?? 'Yes'}
                        />
                    }
                </div>
            </div>
        </Popup>
    )
}